/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_SavedInputs */

const en_action_saved = /** @type {(inputs: Action_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const id_action_saved = /** @type {(inputs: Action_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersimpan`)
};

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const es_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const fr_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const de_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const ja_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const zh_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const ar_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const it_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const ru_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const pt_action_saved = en_action_saved;

/** @type {(inputs: Action_SavedInputs) => LocalizedString} */
const ko_action_saved = en_action_saved;

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Action_SavedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_saved = /** @type {((inputs?: Action_SavedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_SavedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_saved(inputs)
	if (locale === "es") return es_action_saved(inputs)
	if (locale === "fr") return fr_action_saved(inputs)
	if (locale === "de") return de_action_saved(inputs)
	if (locale === "ja") return ja_action_saved(inputs)
	if (locale === "zh") return zh_action_saved(inputs)
	if (locale === "ar") return ar_action_saved(inputs)
	if (locale === "id") return id_action_saved(inputs)
	if (locale === "it") return it_action_saved(inputs)
	if (locale === "ru") return ru_action_saved(inputs)
	if (locale === "pt") return pt_action_saved(inputs)
	return ko_action_saved(inputs)
});